import cls from "./asyncSelect.module.scss";
import React from "react";
import ArrowDownLineIconPath from "public/images/arrow_down.svg";
import Image from "next/image";
import usePopover from "hooks/usePopover";
import PopoverContainer from "containers/popover/popover";
import { useInfiniteQuery } from "react-query";
import request from "services/request";
import { CircularProgress } from "@mui/material";
import CheckboxCircleFillIcon from "remixicon-react/CheckboxCircleFillIcon";
import CheckboxBlankCircleLineIcon from "remixicon-react/CheckboxBlankCircleLineIcon";

type Props = {
  queryKey: string;
  value?: any;
  label?: string;
  icon?: React.ReactElement;
  extractTitle: (data: any) => string;
  extractKey: (data: any) => string | number;
  onChange?: (item: any) => void;
  filter?: (data: any) => void;
  fullWidth?: boolean;
};

export default function AsyncSelect({
  queryKey,
  extractTitle,
  extractKey,
  label,
  icon,
  value,
  onChange,
  filter,
  fullWidth = false,
}: Props) {
  const [open, anchor, handleOpen, handleClose] = usePopover();

  const { data, isLoading } = useInfiniteQuery({
    queryKey,
    queryFn: () => request.get(queryKey),
    enabled: open,
    staleTime: 0,
  });

  let extractedData = data?.pages?.flatMap((item) => item?.data || []) || [];

  if (filter) {
    extractedData = extractedData.filter(filter);
  }

  const handleChange = (item: any) => {
    handleClose();
    if (onChange) {
      onChange(item);
    }
  };

  return (
    <div className={`${cls.container} ${fullWidth && cls.fullWidth}`}>
      <button className={cls.button} type="button" onClick={handleOpen}>
        <div className={cls.mainContainer}>
          <span className={cls.iconContainer}>{icon}</span>
          <div>
            {label && <span className={cls.label}>{label} </span>}
            {value && (
              <span className={cls.value}>- {extractTitle(value)}</span>
            )}
          </div>
        </div>
        <span className={`${cls.dropdownIcon} ${open && cls.open}`}>
          <Image
            src={ArrowDownLineIconPath}
            alt="arrow"
            width={24}
            height={24}
          />
        </span>
      </button>
      <PopoverContainer
        open={open}
        anchorEl={anchor}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 70,
          horizontal: 0,
        }}
        customStyles={{
          borderRadius: "15px",
        }}
      >
        <div className={cls.popoverContainer}>
          {isLoading && <CircularProgress size={20} />}
          {extractedData.map((item) => (
            <button
              type="button"
              key={extractKey(item)}
              className={cls.row}
              onClick={(e) => {
                e.stopPropagation();
                handleChange(item);
              }}
            >
              <div className={cls.radio}>
                {extractKey(item) === extractKey(value) ? (
                    <span className={cls.checked}>
                  <CheckboxCircleFillIcon />
                    </span>
                ) : (
                    <span className={cls.blank}>

                  <CheckboxBlankCircleLineIcon />
                    </span>
                )}
              </div>
              {extractTitle(item)}
            </button>
          ))}
        </div>
      </PopoverContainer>
    </div>
  );
}
